<template>
  <div class="page faq-page">
    <section class="faq-hero">
      <div class="hero-content">
        <p class="eyebrow">{{ isEnglish ? 'Help center' : 'Centre d’aide' }}</p>
        <h1>{{ isEnglish ? 'Frequently Asked Questions' : 'Questions fréquentes' }}</h1>
        <p>{{ isEnglish ? 'Simple answers about rates, exchange services, transfers, and how to contact Nyenyezia Forex.' : 'Des réponses simples sur les taux, le change, les transferts et la façon de contacter Nyenyezia Forex.' }}</p>
      </div>
    </section>

    <section class="faq">
      <div class="faq-list">
        <article class="faq-item" v-for="(faq, index) in displayedFaqs" :key="index">
          <span class="faq-number">{{ String(index + 1).padStart(2, '0') }}</span>
          <h3 class="faq-question">{{ faq.question }}</h3>
          <p class="faq-answer">{{ faq.answer }}</p>
        </article>
      </div>
      <div class="faq-cta">
        <h2>{{ isEnglish ? 'Still have a question?' : 'Vous avez encore une question ?' }}</h2>
        <p>{{ isEnglish ? 'Contact the team before confirming your exchange or transfer.' : 'Contactez l’équipe avant de confirmer votre change ou votre transfert.' }}</p>
        <router-link :to="localizedPath('/contact')" class="cta-button">{{ isEnglish ? 'Contact Us' : 'Nous contacter' }}</router-link>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "FaqPage",
  data() {
    return {
      faqs: [
        {
          question: "Comment consulter les taux ?",
          answer: "Vous pouvez consulter les taux sur la page Taux de change ou sur le tableau d’affichage. Les taux achat et vente sont présentés séparément pour plus de clarté.",
        },
        {
          question: "Les taux sont-ils mis à jour automatiquement ?",
          answer: "Les taux publics utilisent une source externe côté serveur et les marges configurées par l’administration. Ils peuvent être rafraîchis selon la configuration en place.",
        },
        {
          question: "Comment contacter Nyenyezia Forex ?",
          answer: "Utilisez la page Contact pour envoyer une demande ou obtenir une assistance avant une opération de change ou de transfert.",
        },
        {
          question: "Quels services sont offerts ?",
          answer: "Nyenyezia Forex offre l’échange de devises, l’accompagnement pour les transferts d’argent, la consultation et l’affichage clair des taux.",
        },
        {
          question: "Est-ce que les taux affichés peuvent changer ?",
          answer: "Oui. Les taux de change peuvent évoluer selon le marché, la disponibilité des devises et les marges appliquées. Le taux final doit être confirmé avant l’opération.",
        },
        {
          question: "Comment fonctionne l’achat et la vente de devises ?",
          answer: "Le taux d’achat indique le prix auquel la devise est achetée au client. Le taux de vente indique le prix auquel la devise est vendue au client.",
        },
      ],
      faqsEn: [
        {
          question: "How can I check the rates?",
          answer: "You can check rates on the Exchange Rates page or on the public rate board. Buy and sell rates are shown separately for clarity.",
        },
        {
          question: "Are rates updated automatically?",
          answer: "Public rates use an external source on the server and the margins configured by the admin. They may refresh according to the active configuration.",
        },
        {
          question: "How do I contact Nyenyezia Forex?",
          answer: "Use the Contact page to send a request or get support before a currency exchange or money transfer.",
        },
        {
          question: "What services are offered?",
          answer: "Nyenyezia Forex offers currency exchange, support for money transfers, consultation, and clear rate display.",
        },
        {
          question: "Can displayed rates change?",
          answer: "Yes. Exchange rates can change depending on the market, currency availability, and applied margins. The final rate should be confirmed before the transaction.",
        },
        {
          question: "How do currency buy and sell rates work?",
          answer: "The buy rate is the rate at which the currency is bought from the customer. The sell rate is the rate at which the currency is sold to the customer.",
        },
      ],
    }
  },
  computed: {
    isEnglish() {
      return this.$route.path.startsWith('/en');
    },
    displayedFaqs() {
      return this.isEnglish ? this.faqsEn : this.faqs;
    }
  },
  methods: {
    localizedPath(path) {
      if (!this.isEnglish) return path;
      return path === '/' ? '/en' : '/en' + path;
    }
  }
};
</script>

<style scoped>
.faq-page {
  background: #f5f7fb;
  color: #001041;
}
.faq-hero {
  background:
    linear-gradient(90deg, rgba(0,16,65,0.88), rgba(0,16,65,0.62)),
    url('@/assets/faq.jpg');
  background-position: center;
  background-size: cover;
  color: white;
  padding: 98px 20px 84px;
  text-align: center;
}
.hero-content {
  margin: 0 auto;
  max-width: 780px;
}
.eyebrow {
  color: #c39446;
  font-size: 0.84rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  margin: 0 0 10px;
  text-transform: uppercase;
}
.faq-hero h1 {
  font-size: clamp(2.4rem, 5vw, 4.2rem);
  line-height: 1.08;
  margin: 0;
}
.faq-hero p {
  font-size: 1.12rem;
  line-height: 1.65;
  margin: 18px auto 0;
  max-width: 700px;
}
.faq {
  padding: 76px 20px 90px;
}
.faq-list {
  display: grid;
  gap: 18px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin: 0 auto;
  max-width: 1080px;
}
.faq-item {
  background: #fff;
  border: 1px solid #dfe4ee;
  border-radius: 8px;
  box-shadow: 0 16px 38px rgba(0,16,65,0.08);
  padding: 24px;
}
.faq-number {
  color: #c39446;
  display: block;
  font-weight: 900;
  margin-bottom: 12px;
}
.faq-question {
  color: #001041;
  font-size: 1.16rem;
  margin: 0 0 10px;
}
.faq-answer {
  color: #4d5a70;
  line-height: 1.62;
  margin: 0;
}
.faq-cta {
  background: #001041;
  border-radius: 8px;
  color: #fff;
  margin: 34px auto 0;
  max-width: 1080px;
  padding: 30px;
  text-align: center;
}
.faq-cta h2 {
  margin: 0 0 8px;
}
.faq-cta p {
  margin: 0 0 20px;
}
.cta-button {
  background-color: #c39446;
  border-radius: 5px;
  color: white;
  display: inline-block;
  font-weight: 700;
  padding: 12px 20px;
  text-decoration: none;
}
@media (max-width: 760px) {
  .faq-hero {
    padding: 82px 18px 70px;
  }
  .faq-list {
    grid-template-columns: 1fr;
  }
  .cta-button {
    width: 100%;
  }
}
</style>
